module.exports = __webpack_public_path__ + "media/icons/pochodzenie-kraj@3x-d13c1bd6.svg";